import { get } from 'lodash-es';

export const selectView = (state) => get(state, 'view');
export const selectId = (state) => get(selectView(state), 'id');
